import * as React from 'react'
import {createStyles, Theme, WithStyles, withStyles, Typography, TableCell, Chip, Icon, IconButton} from '@material-ui/core'
import {withI18n, WithI18n} from 'src/core/i18n/withI18n'
import {compose} from 'redux'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import { Datatable, DatatableToolbar, DatatableHead, DatatableBody } from 'src/shared/Datatable'
import { TableSortCell } from 'src/shared/TableSort'
import { PaginateAction } from 'src/core/redux/action/paginateAction'
import DatatableRow from 'src/shared/Datatable/DatatableRow'
import { ISignature } from 'src/type/signature'
import { fetchDocSigned } from 'src/core/redux/action/signaturesAction'
import { SignatureCriteria } from 'src/type/criteria/signatureCriteria'
import DatatableFilters from 'src/shared/Datatable/Filters/DatatableFilters'
import { getUserBestNameWithoutEmail, replaceDetteWithTaux } from 'src/shared/utils/helpers'
import SignatureCategoriesFilter from 'src/shared/CategoriesFilter/SignatureCategoriesFilter'
import Alert from 'src/shared/Alert/Alert'

const styles = (t: Theme) => createStyles({
    chip: {
        margin: '4px',
        fontSize: '0.75rem',
        height: '26px'
    },
    tableWpr: {
        width: '100%',
        overflow: 'auto'
    }
});

const paginateName = 'signatures';
const paginateAction = fetchDocSigned;
const actions = new PaginateAction<any>(paginateName, paginateAction)

interface IProps extends WithStyles<typeof styles>,
  WithI18n,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
}

class DocumentSigned extends React.Component<IProps, any> {

    render(){
        const { t, classes, categories, mapName } = this.props;
        return(
            <div className={classes.tableWpr}>
                <Alert type="info">
                    Seuls les documents signés électroniquement sur le portail Salle des Marchés sont visible dans l’onglet
                    <span style={{fontSize: '1.1rem', fontWeight: 'bold', marginLeft: '3px'}}>Documents signés</span>
                </Alert>
                <br />
                <Datatable
                  name={paginateName}
                  action={paginateAction}
                  isExpendRow={true}
                >
                    <DatatableFilters>
                        <SignatureCategoriesFilter 
                            display={t.categories}
                            label={"categories"}
                            categoriesDispo={["Document","Principale","Produit"]}
                            categories={categories}
                            mapName={mapName}
                        />
                    </DatatableFilters>
                    <DatatableToolbar search="global_search"/>
                    <DatatableHead>
                        <TableSortCell name="created_at">{t.signature_date_signature}</TableSortCell>
                        <TableSortCell name="fileName">{t.document}</TableSortCell>
                        <TableCell>{t.categories}</TableCell>
                        <TableCell >{t.downloading}</TableCell>
                    </DatatableHead>
                    <DatatableBody renderRow={this.renderRow}/>
                </Datatable>
            </div>
        )
      }
    
      @autobind
      private renderRow(s: ISignature) {
        const {formatDate, t} = this.props
        return (
          <DatatableRow expendedChild={this.renderExpendedRow(s)}>
            <TableCell style={{maxWidth: 100}}>{formatDate(s.created_at)}</TableCell>
            <TableCell style={{whiteSpace: 'normal', wordBreak: 'break-all'}}>{s.fileName}</TableCell>
            <TableCell style={{whiteSpace: 'normal', wordBreak: 'break-all'}}>{this.renderCategoriesCol(s)}</TableCell>
            <TableCell>
                <IconButton 
                    aria-label={t.downloading}
                    style={{cursor: 'pointer'}}
                    disabled={!s.signedFileUrl}
                    onClick={this.handleDownload(s.signedFileUrl)}
                >
                    <Icon>get_app</Icon>
                </IconButton>
            </TableCell>
          </DatatableRow>
        )
      }
    
      private renderExpendedRow(s: ISignature): React.ReactChild {
        const {t} = this.props
        return (
          <>
          <Typography variant="inherit" gutterBottom>
                <span style={{fontWeight: 'bold'}}>{t.signature_signatory} </span> : 
                <span style={{marginLeft: '3px'}}>{(s.firstName && s.lastName) ? getUserBestNameWithoutEmail({first_name: s.firstName, last_name: s.lastName}) : '-'}</span>
            </Typography>

            <Typography variant="inherit" gutterBottom>
                <span style={{fontWeight: 'bold'}}>{t.signature_mail_signatory} </span> : 
                <span style={{marginLeft: '3px'}}>{s.email ? s.email : '-'}</span>
            </Typography>

            <Typography variant="inherit" gutterBottom>
                <span style={{fontWeight: 'bold'}}>{t.signature_phone_signatory} </span> : 
                <span style={{marginLeft: '3px'}}>{s.phone ? s.phone : '-'}</span>
            </Typography>
          </>
        )
      }

      private renderCategoriesCol(s: ISignature){
        const {mapName, classes} = this.props
        return (
            <>
                {s.category_document && s.category_document.length > 0 &&
                    s.category_document.split(",").map(c => 
                        mapName.get(c) !== undefined ? <Chip key={`${s.id}-category-document-${s.id}`} label={mapName.get(c)} className={classes.chip}/> : ''
                    )
                }
                {s.category_produit && s.category_produit.length > 0 &&
                    s.category_produit.split(",").map(c => 
                        mapName.get(c) !== undefined ? <Chip key={`${s.id}-category-produit-${s.id}`} label={mapName.get(c)} className={classes.chip}/> : ''
                    )
                }
                {s.category_principale && s.category_principale.length > 0 &&
                    s.category_principale.split(",").map(c => 
                        mapName.get(c) !== undefined ? <Chip key={`${s.id}-category-principale-${s.id}`} label={replaceDetteWithTaux(mapName.get(c))} className={classes.chip}/> : ''
                    )
                }   
                {s.category_type && s.category_type.length > 0 &&
                    s.category_type.split(",").map(c =>
                        mapName.get(c) !== undefined ? <Chip key={`${s.id}-category-type-${s.id}`} label={mapName.get(c)} className={classes.chip}/> : ''
                    )
                }
            </>
        )
          
      }

      handleDownload = url => e => {
          window.open(url, "_blank")
      }

      componentDidMount(){
          this.props.resetCriteriaByObject({sort_by: "created_at", order_by: "desc", limit: 10, offset: 0})
      }

}

const state2props = (state: RootState) => ({
    connectedUser: state.accountInfo.connectedUser,
    enterprise: state.accountInfo.enterpriseSelected,
    criteria: state.paginate.signatures.criteria,
    signatures: state.paginate.signatures.entities,
    categories: state.categories.entities,
    mapName: state.utils.mapCategories
});

const dispatch2props = dispatch => ({
    updateCriteriaByObject: (object: any) => dispatch(actions.updateCriteriaByObject(object)),
    fetch: (c: SignatureCriteria) => dispatch(fetchDocSigned(c)),
    resetCriteriaByObject: (object: any) => dispatch(actions.resetCriteriaByObject(object)),
});

export default compose(
  withI18n,
  connect(state2props, dispatch2props),
  withStyles(styles)
)(DocumentSigned)



// WEBPACK FOOTER //
// ./src/page/Consumer/Signature/tabs/DocumentSigned.tsx